import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";
import { showErrorModal } from "slices/app/actions/error";
import { addToJobQueue, removeFromJobQueue } from "slices/app/appSlice";
import { startSSEConnection } from "slices/workspace/actions/uploadFiles";

import { DOCUMENT_EDITOR_CONFIG } from "../documents/documentsSlice";
import { parseScoringError } from "../errorActions";
import { resetScoring, setIsRescanning } from "./analysis/analysisSlice";
import { resetEditing } from "./edit/editAnalysisSlice";

const buildScoringUrl = (
  { endpoint, entityType, originId, documentId, versionId },
  suffix
) => {
  if (entityType === "UNLINKED") {
    return `${endpoint}/${originId}/${suffix}/${versionId}`;
  }
  return `${endpoint}/${originId}/${documentId}/${suffix}/${versionId}`;
};

const createScoringFetchThunk = ({ typePrefix, jobName, urlSuffix }) =>
  createAsyncThunk(
    typePrefix,
    async ({ documentId, entityType, originId, versionId }, { dispatch }) => {
      dispatch(addToJobQueue(jobName));
      try {
        const { endpoint } = DOCUMENT_EDITOR_CONFIG[entityType];
        const url = buildScoringUrl(
          { endpoint, entityType, originId, documentId, versionId },
          urlSuffix
        );
        const rsp = await localhost.get(url);
        return rsp?.data;
      } catch (err) {
        dispatch(parseScoringError(err));
        return null;
      } finally {
        dispatch(removeFromJobQueue(jobName));
      }
    }
  );

export const getAnalysisByScanId = createScoringFetchThunk({
  typePrefix: "write/scoring/get",
  jobName: "getAnalysisByScanId",
  urlSuffix: "issues",
});

export const getMetadataByScanId = createScoringFetchThunk({
  typePrefix: "writing/scoring/getMetadata",
  jobName: "getMetadataByScanId",
  urlSuffix: "summary",
});

export const resetScoringMode = () => (dispatch) => {
  dispatch(resetScoring());
  dispatch(resetEditing());
};

export const rescanDocument =
  ({ documentId, entityType, originId, versionId }) =>
  async (dispatch) => {
    dispatch(setIsRescanning(true));
    try {
      const { endpoint } = DOCUMENT_EDITOR_CONFIG[entityType];
      const url = buildScoringUrl(
        { endpoint, entityType, originId, documentId, versionId },
        "rescan"
      );
      const { data } = await localhost.post(url);
      if (data?.flowId) {
        dispatch(startSSEConnection(data.flowId));
      }
    } catch (err) {
      dispatch(showErrorModal(err));
    } finally {
      dispatch(setIsRescanning(false));
    }
  };
